import axios from '@axios'
import baseConfig from '@/config/index'

const EBARIMT_SERVICE_PATH = baseConfig.EBARIMT_SERVICE_PATH

export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    fetchLoanEbarimtRegistry(ctx, payload) {
      const params = {
        limit: payload.limit,
        offset: payload.offset,
      }
      if (payload.due_date_from) params.due_date_from = payload.due_date_from
      if (payload.due_date_to) params.due_date_to = payload.due_date_to
      if (payload.customer_id) params.customer_id = payload.customer_id
      if (payload.loan_account_id) params.loan_account_id = payload.loan_account_id
      if (payload.status) params.status = payload.status
      if (payload.trigger_type) params.trigger_type = payload.trigger_type

      return new Promise((resolve, reject) => {
        axios
          .get(`${EBARIMT_SERVICE_PATH}/v3/loan-ebarimt/registry`, { params })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    fetchLoanEbarimtDetail(ctx, payload) {
      return new Promise((resolve, reject) => {
        axios
          .get(`${EBARIMT_SERVICE_PATH}/v3/loan-ebarimt/registry/${payload.entry_id}`)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    fetchLoanEbarimtDailyReport(ctx, payload) {
      const params = {
        limit: payload.limit,
        offset: payload.offset,
      }

      return new Promise((resolve, reject) => {
        axios
          .get(`${EBARIMT_SERVICE_PATH}/v3/loan-ebarimt/registry/daily-report`, { params })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    sendLoanEbarimtRegistry(ctx, payload) {
      const body = {
        due_date_from: payload.due_date_from,
        due_date_to: payload.due_date_to,
        force: payload.force || false,
      }
      if (payload.customer_id) body.customer_id = payload.customer_id
      if (payload.loan_account_id) body.loan_account_id = payload.loan_account_id
      if (payload.entry_id) body.entry_id = payload.entry_id
      if (payload.limit) body.limit = payload.limit

      return new Promise((resolve, reject) => {
        axios
          .post(`${EBARIMT_SERVICE_PATH}/v3/loan-ebarimt/registry/send`, body, { timeout: 600000 })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
  },
}
